import { render, staticRenderFns } from "./FoodBasicInfo.vue?vue&type=template&id=2fcfb6c8"
import script from "./FoodBasicInfo.vue?vue&type=script&lang=js"
export * from "./FoodBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports